import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { getAllWarehouses, getWareHouseById } from './thunks';
import { WareHousesState } from './state';

// Initial state for Redux store:
export const initialStateWarehouses: WareHousesState = {
  warehouses: {
    total: 0,
    warehouses: [],
    paginate: {
      current_page: 1,
      items: 0,
      pages: 1,
    },
    success: false,
  },
  selectedWarehouse: {
    address: '',
    barcode: '',
    id: 0,
    name: '',
    status_warehouses_id: 0,
    time_zone: {
      id: 0,
      pytz_zone: '',
    },
  },
  loading: false,
};

const finishLoading = (state: WareHousesState) => {
  state.loading = false;
};
const startLoading = (state: WareHousesState) => {
  state.loading = true;
};

const warehousesSlice = createSlice({
  name: 'warehouses',
  initialState: initialStateWarehouses, // Define initial state
  reducers: {
    setWarehouses: (state: any, action: any) => {
      state.warehouses = action.payload;
    },
    setSelectedWarehouse: (state: any, action: any) => {
      localStorage.setItem('selectedWarehouse', JSON.stringify(action.payload));
      state.selectedWarehouse = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllWarehouses.pending, startLoading);
    builder.addCase(getAllWarehouses.rejected, finishLoading);
    builder.addCase(getAllWarehouses.fulfilled, (state, action) => {
      state.warehouses = action.payload;
      state.loading = false;
    });
    builder.addCase(getWareHouseById.rejected, finishLoading);
    builder.addCase(getWareHouseById.pending, startLoading);
    builder.addCase(getWareHouseById.fulfilled, (state, action) => {
      state.edit = action.payload;
      state.loading = false;
    });
  },
});

// Export actions generated by "createSlice()":
export const { setWarehouses, setSelectedWarehouse } = warehousesSlice.actions;

// Export reducer generated by "createSlice()":
export default warehousesSlice.reducer;
